import { Checkbox, Table } from 'antd';
import * as React from 'react'
import { DisplayProperties } from './MainCSoftAccess';
declare var $: any

type ProductKey = keyof DisplayProperties['affichage']['affichage_products']['pdm_product']
const PRODUCT_IDS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'] as const

interface IProps {
  isEdit:               boolean
  displayProperties:    DisplayProperties
  setDisplayProperties: React.Dispatch<React.SetStateAction<DisplayProperties>>
}

export default function CDisplayProperties(props: IProps){

    return (
      <>
      <div style={{marginLeft: '25%'}}>
          <Checkbox 
            id       = "affichage_affichage_pots_accessibles"
            style    = {{marginBottom: '20px'}}
            checked  = {props.displayProperties.affichage.affichage_pots_accessibles}
            onChange = {(e) => {
              props.setDisplayProperties({
                ...props.displayProperties,
                affichage: {
                  ...props.displayProperties.affichage,
                  affichage_pots_accessibles: e.target.checked
                }
              })
            }}
          >
            Potentiels accessibles (rangs 1, 2 et 3)
          </Checkbox>
          <br/>
          <Checkbox 
          id         = "affichage_affichage_pots_exploites"
            style    = {{marginBottom: '20px'}}
            checked  = {props.displayProperties.affichage.affichage_pots_exploites}
            onChange = {(e) => {
              props.setDisplayProperties({
                ...props.displayProperties,
                affichage: {
                  ...props.displayProperties.affichage,
                  affichage_pots_exploites: e.target.checked
                }
              })
            }}
          >
            Potentiels exploités (rangs 4 et 5)
          </Checkbox>
          <div className="div-2-chekbox">
            <Checkbox 
              id       = "affichage_affichage_pistes"
              checked  = {props.displayProperties.affichage.affichage_pistes}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_pistes: e.target.checked
                  }
                })
              }}
            >
              Pistes
            </Checkbox>
            <Checkbox 
              id       = "affichage_affichage_pistes_rg5_popup_map"
              checked  = {props.displayProperties.affichage.affichage_pistes_rg5_popup_map}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_pistes_rg5_popup_map: e.target.checked
                  }
                })
              }}
            >
              Rg5 carte popup
            </Checkbox>
          </div>
          <div className="div-2-chekbox">
            <Checkbox 
              id       = "affichage_affichage_gains"
              checked  = {props.displayProperties.affichage.affichage_gains}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_gains: e.target.checked
                  }
                })
              }}
            >
              Gains
            </Checkbox>
            <Checkbox 
              id       = "affichage_affichage_gains_rg5_popup_map"
              checked  = {props.displayProperties.affichage.affichage_gains_rg5_popup_map}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_gains_rg5_popup_map: e.target.checked
                  }
                })
              }}
            >
              Rg5 carte popup
            </Checkbox>
          </div>
          <div className="div-2-chekbox">
            <Checkbox 
              id       = "affichage_affichage_pdm"
              checked  = {props.displayProperties.affichage.affichage_pdm}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_pdm: e.target.checked
                  }
                })
              }}
            >
              Pdm
            </Checkbox>
            <Checkbox 
              id       = "affichage_affichage_pdm_rg5_popup_map"
              checked  = {props.displayProperties.affichage.affichage_pdm_rg5_popup_map}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_pdm_rg5_popup_map: e.target.checked
                  }
                })
              }}
            >
              Rg5 carte popup
            </Checkbox>
          </div>
          <div className="div-2-chekbox">
            <Checkbox 
              id       = "affichage.affichage_ventes"
              checked  = {props.displayProperties.affichage.affichage_ventes}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_ventes: e.target.checked
                  }
                })
              }}
            >
              Ventes
            </Checkbox>
            <Checkbox 
              id       = "affichage_affichage_ventes_rg5_popup_map"
              checked  = {props.displayProperties.affichage.affichage_ventes_rg5_popup_map}
              onChange = {(e) => {
                props.setDisplayProperties({
                  ...props.displayProperties,
                  affichage: {
                    ...props.displayProperties.affichage,
                    affichage_ventes_rg5_popup_map: e.target.checked
                  }
                })
              }}
            >
              Rg5 carte popup
            </Checkbox>
          </div>
      </div>
      <div style={{marginBottom: '40px', marginLeft: '0% !important'}} className="col-xs-9 col-xs-offset-3">
        <table>
          <thead>
            <tr>
              <th style={{width: '100px'}}></th>
              <th className="table-title-head">Pdm</th>
              <th className="table-title-head">Gain</th>
              <th className="table-title-head">Affichage résumé gauche</th>
              <th className="table-title-head">Données tbc</th>
              <th className="table-title-head">Affichage rg5</th>
              <th className="table-title-head">Affichage rg4</th>
              <th className="table-title-head">Affichage rg3</th>
              <th className="table-title-head">Affichage rg2</th>
              <th className="table-title-head">Affichage rg1</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{paddingTop: '10px'}}>Potentiel global</td>
              <td className="table-checkbox-row"></td>
              <td className="table-checkbox-row"></td>
              <td className="table-checkbox-row"></td>
              <td className="table-checkbox-row">
                <Checkbox 
                  id       = "affichage_pot_total_tbc"
                  checked  = {props.displayProperties.affichage.pot_total_tbc}
                  onChange = {(e) => {
                    props.setDisplayProperties({
                      ...props.displayProperties,
                      affichage: {
                        ...props.displayProperties.affichage,
                        pot_total_tbc: e.target.checked
                      }
                    })
                  }}
                >
                </Checkbox>
              </td>
            </tr>
            {PRODUCT_IDS.map((idProduct, index) => {
              const productKey = `prod${idProduct}` as ProductKey
              return (
              <tr key={index} style={{backgroundColor: (index % 2 == 1) ?  '#f7f7f7' : 'white' }}>
                <td>Produit {idProduct}</td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_pdm_product_prod${idProduct}`}
                    checked  = {props.displayProperties.affichage.affichage_products.pdm_product[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            pdm_product: {
                              ...props.displayProperties.affichage.affichage_products.pdm_product,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_gain_product_prod${idProduct}`}
                    checked  = {props.displayProperties.affichage.affichage_products.gain_product[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            gain_product: {
                              ...props.displayProperties.affichage.affichage_products.gain_product,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_resume_left_prod${idProduct}`}
                    checked  = {props.displayProperties.affichage.affichage_products.resume_left[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            resume_left: {
                              ...props.displayProperties.affichage.affichage_products.resume_left,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_tbc_data_prod${idProduct}`}
                    checked  = {props.displayProperties.affichage.affichage_products.tbc_data[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            tbc_data: {
                              ...props.displayProperties.affichage.affichage_products.tbc_data,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_showPotRg5_prod${idProduct}`}
                    style    = {{marginBottom: '15px', marginTop: '10px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showPotRg5[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showPotRg5: {
                              ...props.displayProperties.affichage.affichage_products.showPotRg5,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    pot
                  </Checkbox>
                  <Checkbox 
                    id       = {`affichage_affichage_products_showCaRg5_prod${idProduct}`}
                    style    = {{marginLeft: '-5px', marginBottom: '15px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showCaRg5[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showCaRg5: {
                              ...props.displayProperties.affichage.affichage_products.showCaRg5,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    ca
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_showPotRg4_prod${idProduct}`}
                    style    = {{marginBottom: '15px', marginTop: '10px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showPotRg4[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showPotRg4: {
                              ...props.displayProperties.affichage.affichage_products.showPotRg4,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    pot
                  </Checkbox>
                  <Checkbox 
                    id       = {`affichage_affichage_products_showCaRg4_prod${idProduct}`}
                    style    = {{marginLeft: '-5px', marginBottom: '15px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showCaRg4[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showCaRg4: {
                              ...props.displayProperties.affichage.affichage_products.showCaRg4,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    ca
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id      = {`affichage_affichage_products_showPotRg3_prod${idProduct}`}
                    style   = {{marginBottom: '15px', marginTop: '10px'}}
                    checked = {props.displayProperties.affichage.affichage_products.showPotRg3[productKey]}
                    onChange= {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showPotRg3: {
                              ...props.displayProperties.affichage.affichage_products.showPotRg3,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    pot
                  </Checkbox>
                  <Checkbox 
                    id      = {`affichage_affichage_products_showCaRg3_prod${idProduct}`}
                    style   = {{marginLeft: '-5px', marginBottom: '15px'}}
                    checked = {props.displayProperties.affichage.affichage_products.showCaRg3[productKey]}
                    onChange= {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showCaRg3: {
                              ...props.displayProperties.affichage.affichage_products.showCaRg3,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    ca
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_showPotRg2_prod${idProduct}`}
                    style    = {{marginBottom: '15px', marginTop: '10px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showPotRg2[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showPotRg2: {
                              ...props.displayProperties.affichage.affichage_products.showPotRg2,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    pot
                  </Checkbox>
                  <Checkbox 
                    id       = {`affichage_affichage_products_showCaRg2_prod${idProduct}`}
                    style    = {{marginLeft: '-5px', marginBottom: '15px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showCaRg2[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showCaRg2: {
                              ...props.displayProperties.affichage.affichage_products.showCaRg2,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    ca
                  </Checkbox>
                </td>
                <td className="table-checkbox-row">
                  <Checkbox 
                    id       = {`affichage_affichage_products_showPotRg1_prod${idProduct}`}
                    style    = {{marginBottom: '15px', marginTop: '10px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showPotRg1[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showPotRg1: {
                              ...props.displayProperties.affichage.affichage_products.showPotRg1,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    pot
                  </Checkbox>
                  <Checkbox 
                    id       = {`affichage_affichage_products_showCaRg1_prod${idProduct}`}
                    style    = {{marginLeft: '-5px', marginBottom: '15px'}}
                    checked  = {props.displayProperties.affichage.affichage_products.showCaRg1[productKey]}
                    onChange = {(e) => {
                      props.setDisplayProperties({
                        ...props.displayProperties,
                        affichage: {
                          ...props.displayProperties.affichage,
                          affichage_products: {
                            ...props.displayProperties.affichage.affichage_products,
                            showCaRg1: {
                              ...props.displayProperties.affichage.affichage_products.showCaRg1,
                              [productKey]: e.target.checked
                            }
                          }
                        }
                      })
                    }}
                  >
                    ca
                  </Checkbox>
                </td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
      </>
    )                   
}
